import type { DeviceFilter } from "./types";

export const FILTER_TABS: ReadonlyArray<{ key: DeviceFilter; label: string }> =
  [
    { key: "all", label: "All" },
    { key: "in-process", label: "In Process" },
    { key: "shipped", label: "Shipped" },
    { key: "delivered", label: "Delivered" },
    { key: "active", label: "Active" },
  ];

export const STATUS_LABELS: Record<DeviceFilter, string> = {
  all: "All",
  "in-process": "In Process",
  shipped: "Shipped",
  delivered: "Delivered",
  active: "Active",
};

const MY_DEVICES = {
  DEFAULT_FILTER: "all" as DeviceFilter,
  SKELETON_COUNT: 3,
  MAC_ADDRESS: {
    PATTERN: /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/,
    PLACEHOLDER: "A1:B2:C3:D4:E5:F6",
  },
  LABELS: {
    TITLE: "My Devices",
    EMPTY: "No home phone devices found",
    ORDER_PREFIX: "Order:",
    ACTIVATE: "Activate",
    ACTIVATE_DEVICE: "Activate Device",
    ACTIVATE_HOME_PHONE: "Activate Home Phone",
    MAC_REQUIRED: "MAC address is required",
    DEFAULT_PRODUCT: "Home Phone Device",
    DEFAULT_BRAND: "eFone",
    DEFAULT_TYPE: "home phone",
    ERROR_ACTIVATE: "Unable to activate device.",
  },
} as const;

export default MY_DEVICES;
